import { render, staticRenderFns } from "./funecM_Pres.vue?vue&type=template&id=b98628c4"
import script from "./funecM_Pres.vue?vue&type=script&lang=js"
export * from "./funecM_Pres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports